const SIZE_PARAM_REGEX = /[?&]prev_iu_szs=([^&#]*)/;

function extractSizesFromUrl(url: string | undefined): string {
  if (!url) {
    return "";
  }

  const match = url.match(SIZE_PARAM_REGEX);
  return match ? decodeURIComponent(match[1]) : "";
}

/**
 * Uses the `contentUrl` from the slot to extract the sizes from `prev_iu_szs` key-value.
 */
export function parseSizes(slot: googletag.Slot): string[] {
  if (!slot) {
    return [];
  }

  const url =
    (slot as unknown as { getContentUrl?: () => string }).getContentUrl?.() ??
    "";

  const sizes = extractSizesFromUrl(url);

  // Split by pipe character and filter out any empty strings
  return sizes ? sizes.split("|").filter(Boolean) : [];
}
